import { Translate } from '@chipinside/translate'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { forwardRef, useRef, useState } from 'react'

import { Icon } from '#/components/Icon'

interface FileFieldProps {
  name?: string
  onChange?: (file: File | null) => void
  error?: string
  value?: string
  label?: string
  required?: boolean
  placeholder?: string
}

export const FileField = forwardRef<HTMLInputElement, FileFieldProps>(
  ({ onChange, value, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement | null>(null)
    const [fileName, setFileName] = useState(value === null ? '' : value)

    const handleClick = () => {
      inputRef.current?.click()
    }

    const handleChange = (event: any) => {
      const file = event.target.files?.[0]
      if (file) setFileName(file.name)

      onChange?.(file)
    }

    return (
      <>
        <input
          {...props}
          ref={el => {
            inputRef.current = el
            if (typeof ref === 'function') ref(el)
            else if (ref) ref.current = el
          }}
          type="file"
          hidden
          onChange={handleChange}
        />

        <TextField
          label={props.label ?? Translate({ messageKey: 'file' })}
          required={props.required}
          placeholder={props.placeholder}
          value={fileName}
          error={Boolean(props.error)}
          helperText={props.error}
          onClick={handleClick}
          fullWidth
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  {value ? (
                    <IconButton
                      onClick={e => {
                        e.stopPropagation()
                        onChange?.(null)
                        setFileName('')
                      }}
                    >
                      <Icon size="large" name="x" />
                    </IconButton>
                  ) : (
                    <IconButton>
                      <Icon size="large" name="attach-file" />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
              readOnly: true,
            },
          }}
        />
      </>
    )
  },
)

FileField.displayName = 'FileField'
